export const GET_JOB_TYPES = 'GET_JOB_TYPES';
export const GET_JOB_TYPE = 'GET_JOB_TYPE';
